import {Box} from '@chakra-ui/react';
import type {FC, PropsWithChildren} from 'react';

import {useStyles} from './context';
import {parts} from './theme/anatomy';

export const NavFooter: FC<PropsWithChildren> = props => {
  const {children} = props;
  const {footer: style} = useStyles();
  return (
    <Box sx={style} {...parts.footer.attrs}>
      {children}
    </Box>
  );
};

export default NavFooter;
